import { format } from 'date-fns';

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

const FREQUENCIES = {
    daily: 'Diária',
    weekly: 'Semanal',
    monthly: 'Mensal',
    yearly: 'Anual'
};

/** Valor em reais no formato brasileiro (R$ 1.234,56). */
export const formatCurrency = (value) => currency.format(Number(value) || 0);

/**
 * Data "YYYY-MM-DD" lida como data local: new Date('2026-10-01') é meia-noite UTC
 * e aparecia como o dia anterior no fuso -03:00.
 */
export const parseLocalDate = (value) => {
    if (!value) return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
    if (!match) return new Date(value);
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const formatDate = (value, pattern = 'dd/MM/yyyy') => {
    const date = parseLocalDate(value);
    return date && !isNaN(date) ? format(date, pattern) : '';
};

export const formatFrequency = (frequency) => FREQUENCIES[frequency] || frequency;

/** O banco devolve data zerada quando a recorrência não tem fim. */
export const hasValidEndDate = (endDate) => !!endDate &&
    endDate !== '0000-00-00' &&
    endDate !== '0000-00-00 00:00:00';

const MONTH_MS = 1000 * 60 * 60 * 24 * 30;

/** Texto da coluna "Recorrente", mesma conta de antes (parcela N/X ou número da recorrência). */
export const recurrenceLabel = (transaction) => {
    if (!transaction.isRecurring) return null;
    if (!transaction.isRecurrenceGenerated) return 'Recorrente (Original)';

    const start = new Date(transaction.recurrenceStartDate);
    const current = Math.floor((new Date(transaction.transactionDate) - start) / MONTH_MS) + 1;
    if (hasValidEndDate(transaction.recurrenceEndDate)) {
        const total = Math.floor((new Date(transaction.recurrenceEndDate) - start) / MONTH_MS) + 1;
        return `${current}/${total}`;
    }
    return `Recorrência ${current}`;
};
